import React, {useEffect, useRef} from 'react'
import {useDispatch} from 'react-redux'
import {GridGalleryLoading} from 'components/Accommodation/GridGallery/GridGalleryLoading'
import {HotelDetailsLoading} from 'components/Accommodation/HotelDetails/HotelDetailsLoading'
import {LocationSummaryLoading} from 'components/Accommodation/LocationSummary/LocationSummaryLoading'
import {AccommodationOfferBox} from 'components/Accommodation/Offers/AccommodationOfferBox/AccommodationOfferBox'
import {CheckInCheckOutLoading} from 'components/Accommodation/Policies/CheckInCheckOut/CheckInCheckOutLoading'
import {PopularFacilitiesLoading} from 'components/Accommodation/PopularFacilities/PopularFacilitiesLoading'
import {ReviewSummaryLoading} from 'components/Accommodation/ReviewSummary/ReviewSummaryLoading'

import {PageWidthContainer} from '@daedalus/atlas/helpers/PageWidthContainer'
import useBodyScrollLock from '@daedalus/atlas/Overlay/useBodyScrollLock'
import {trackAccommodationPageFRP} from '@daedalus/core/src/analytics/utils/trackPerformanceMetrics'

import {
  DividerContainer,
  GridGalleryWrapper,
  HotelDetailsWrapper,
  LeftContentWrapper,
  MainContentWrapper,
  ReviewSummaryWrapper,
  RightContentWrapper,
  Wrapper
} from './styles'

export const HotelAccommodationDesktopViewLoading = () => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  useBodyScrollLock({
    ref: wrapperRef
  })
  const dispatch = useDispatch()
  useEffect(() => {
    trackAccommodationPageFRP(dispatch)
  }, [dispatch])

  return (
    <Wrapper ref={wrapperRef}>
      <PageWidthContainer paddingDesktopXsSize="s500">
        <GridGalleryWrapper>
          <GridGalleryLoading />
        </GridGalleryWrapper>
        <MainContentWrapper>
          <LeftContentWrapper>
            <HotelDetailsWrapper>
              <HotelDetailsLoading />
            </HotelDetailsWrapper>
            <LocationSummaryLoading />
            <ReviewSummaryWrapper>
              <ReviewSummaryLoading />
            </ReviewSummaryWrapper>
            <DividerContainer />
            <PopularFacilitiesLoading />
            <DividerContainer />
            <CheckInCheckOutLoading layout="secondary" />
          </LeftContentWrapper>
          <RightContentWrapper>
            <AccommodationOfferBox isLoading />
          </RightContentWrapper>
        </MainContentWrapper>
      </PageWidthContainer>
    </Wrapper>
  )
}
